<template>
  <div class="newsDetail">
    <a-skeleton active  avatar :loading="loading" :title="false" :paragraph="{rows:14}">
      <div>
        <div class="btnRow" v-if="showOperation && !searchOverallFlag">
          <div v-show="editMode && !isNewsAmendment && isAuthor">
            <a-button type="primary" style="margin-right: 10px;margin-left: 10px;" @click.stop="saveEdit">{{$t('news.editPage.save')}}</a-button>
            <a-button @click.stop="cancelEdit">{{$t('news.editPage.cancel')}}</a-button>
          </div>
          <div v-show="isNewsAmendment" v-action:NEWSCONTROLLER_NEWSAMENDMENT>
            <a-button @click.stop="cancelEdit">{{$t('news.editPage.cancel')}}</a-button>
            <a-button type="primary" style="margin-right: 10px;margin-left: 10px;" @click.stop="newsAmendmentSave">{{ $t('key82quedingxiuding') }}</a-button>
          </div>
          <div  v-action:NEWSCONTROLLER_NEWSAMENDMENT>
            <a-button  v-show="!editMode && newsDO.informationType == '交易记录'" @click="newsAmendmentEvent" style="margin-left: 10px;" >
              <pt-icon type="icon-a-shenqing1" class="editIcon"></pt-icon>
              <span>{{ $t('key82xiuding') }}</span>
            </a-button>
          </div>
          <div v-show="!editMode && isAuthor">
            <a-button   @click="editEvent" style="margin-left: 10px;">
              <pt-icon type="icon-bianji1" class="editIcon"></pt-icon>
              <span>{{$t('news.editPage.edit')}}</span>
            </a-button>
          </div>
	        <div v-action:NEWSCONTROLLER_ADMINDELETE >
		        <!--删除其他人的需要权限-->
		        <a-button @click="deleteConfirm" v-show=" !editMode && userInfo.accountDO.id != newsDO.createrId" style="margin-left: 10px;">
			        <pt-icon type="icon-tubiao" class="editIcon"></pt-icon>
			        <span>{{$t('baseVO.delete')}}</span>
		        </a-button>
	        </div>
         
          <!--删除其他人的需要权限-->
          <a-button @click="deleteMyNews"  v-show=" !editMode && userInfo.accountDO.id == newsDO.createrId"  style="margin-left: 10px;">
            <pt-icon type="icon-tubiao" class="editIcon"></pt-icon>
            <span>{{$t('baseVO.delete')}}</span>
          </a-button>

          <div v-if="!editMode">
            <a-button v-if="(newsDO.informationType == '租户动态' || (newsDO.informationType == '业主动态' && newsDO.ownerFlag == 0) ) && !isOldData" @click="transfer">
              <pt-icon type="icon-zhuanhuashuju" class="editIcon"></pt-icon>
              <span>{{$t('news.editPage.transfer')}}</span>
            </a-button>
          </div>
        </div>
        <div class="mainDiv">
          <div class="topRow">
            <div class="topRowLeft">
              <a-avatar :size="64" icon="user" :src="getImageUrl(newsDO.createImg)"/>
              <div class="authorText">{{newsDO !== null ? newsDO.createName : ''}}</div>
            </div>
            <div class="topRowRight">
              <news-type-label :newsType="newsDO!=null ? newsDO.informationType:''"></news-type-label>
              <div class="newsTime" v-if="newsDO!=null">{{newsDO.createTime | dayjs}}</div>
              <div class="citySwitch">
                <pt-icon class="cityIcon" type="icon-ditu" style="cursor: default"></pt-icon>
                <div v-if="!editMode" class="cityText" style="cursor: default">{{newsDO.city}}</div>
                <a-form :form="newsCityForm" v-else style="margin-top:16px;">
                  <a-form-item>
                    <pt-select style="width: 80px;cursor: default" v-decorator="['city',{}]"  :allowClear="false">
                      <a-select-option v-for="c in cityDatas" :key="c.wordKey" :value="c.wordKey">{{c.wordValue}}</a-select-option>
                    </pt-select>
                  </a-form-item>
                </a-form>
              </div>
            </div>
          </div>
          <div v-if="newsDO.transferName != '~'" style="position:absolute;">
            <pt-tag :text="$t('news.transferBy') + newsDO.transferName + $t('news.transferTo')" color="grey" size="small"></pt-tag>
          </div>
          <div v-if="!editMode">
            <div class="likeRow">
              <div class="likeItem" @click="clickDisLike" v-if="filterDislike(newsLikeDOS)">
                <pt-icon type="icon-zan" class="likeIcon"></pt-icon>
                <div>{{newsLikeDOS != null ? newsLikeDOS.filter(e=>e.type == 0).length : 0}}</div>
              </div>
              <div class="likeItem" @click="clickDisLike" v-if="!filterDislike(newsLikeDOS)">
                <pt-icon type="icon-GroupCopy1" class="likeIcon"></pt-icon>
                <div>{{newsLikeDOS != null ? newsLikeDOS.filter(e=>e.type == 0).length : 0}}</div>
              </div>
              <div class="likeItem" @click="clickLike" v-if="filterLike(newsLikeDOS)">
                <pt-icon type="icon-zan1" class="likeIcon"></pt-icon>
                <div>{{newsLikeDOS != null ? newsLikeDOS.filter(e=>e.type == 1).length : 0}}</div>
              </div>
              <div class="likeItem" @click="clickLike" v-if="!filterLike(newsLikeDOS)">
                <pt-icon type="icon-zan2" class="likeIcon"></pt-icon>
                <div>{{newsLikeDOS != null ? newsLikeDOS.filter(e=>e.type == 1).length : 0}}</div>
              </div>
            </div>
            <div v-if="newsDO.informationType == '交易记录'">
              <news-lease-form :is-news-amendment="isNewsAmendment" ref="dealFormRef" :newsDO="newsDO" :disabled="true" :defaultAreaUnit="defaultAreaUnit"></news-lease-form>
            </div>
            <div class="newsContent"  v-else>
              <pre v-html="newsContent" style="white-space: pre-wrap;word-break: break-word;margin-bottom: 0px"></pre>
            </div>
            <span  class="secrecyIcon" v-if="newsDO.informationType != '交易记录' && newsDO.confidentialityStatus == 1"><pt-icon type="icon-baomi1" style="font-size: 30px;;cursor: default"></pt-icon></span>
            <div class="commentDiv">
              <div style="display: flex;flex-direction: column" v-show="commentKey != 'root'">
                <div class="commentBtnRow">
                  <div class="commentBtn" @click="toggleCommentInput">
                    <pt-icon type="icon-pinglun" class="commentIcon"></pt-icon>
                    <span>{{$t('news.editPage.comment')}}</span>
                  </div>
                </div>
                <div v-if="newsDO.likeEmployeeDOList != null && newsDO.likeEmployeeDOList.length > 0">
                  <pt-icon  type="icon-zan2" class="likeIcon" style="margin-right: 20px;cursor: default"></pt-icon>
                  <template v-for="(employeeDO,index) in newsDO.likeEmployeeDOList">
                    <a-avatar :title="employeeDO.userName" style="margin-right: 10px;" icon="user" :size="45" :src="getImageUrl(employeeDO.headimg)"></a-avatar>
                  </template>
                </div>
              </div>
              <div class="commentInput" v-show="commentKey == 'root'">
                <a-form :form="newsCommentDO">
                  <a-form-item>
                    <a-textarea :rows="3" :placeholder="$t('news.editPage.commentTip')" v-decorator="['content',{rules:[
                              {required:true, message:$t('news.editPage.errorInfo.comment')},
                              {min:1,max:256,message:$t('news.editPage.errorInfo.commentLength')}
                              ]}]"></a-textarea>
                  </a-form-item>
                </a-form>
                <div class="commentInputBtnRow">
                  <a-button type="primary"  :loading="saveLoading" @click="submitComment">{{$t('baseVO.confirm')}}</a-button>
                  <a-button @click="cancelComment" style="margin-right:10px;">{{$t('baseVO.cacel')}}</a-button>
                </div>
                <div v-if="newsDO.likeEmployeeDOList != null && newsDO.likeEmployeeDOList.length > 0">
                  <pt-icon  type="icon-zan2" class="likeIcon" style="margin-right: 20px"></pt-icon>
                  <template v-for="(employeeDO,index) in newsDO.likeEmployeeDOList">
                    <a-avatar :title="employeeDO.userName" style="margin-right: 10px;" icon="user" :size="45" :src="getImageUrl(employeeDO.headimg)"></a-avatar>
                  </template>
                </div>
              </div>
              <div v-if="commentTree && commentTree.length > 0">
                <div style="font-size: 12px;color: #666666;">{{$t('news.editPage.comment')}}</div>
                <div v-for="(item,index) in commentTree" class="commentItem">
                  <div>
                    <div class="commentItemTop">
                      <div class="commentItemTopDiv">
                        <a-avatar icon="user" :size="45" :src="getImageUrl(item.tree.commenterImg)"></a-avatar>
                        <div class="commentUser">{{item.tree.createName}}</div>
                      </div>
                      <div class="commentItemTopDiv">
                        <div class="commentTime">{{item.tree.createTime | dayjs}}</div>
                        <div class="commentIconDiv" @click="changeCommentKey(index)">
                          <pt-icon type="icon-pinglun" class="commentIcon"></pt-icon>
                        </div>
                      </div>
                    </div>
                    <div class="commentContentDiv">
                      <i class="contentArrow"></i>
                      <div class="commentContent">{{item.tree.content}}</div>
                    </div>
                    <div v-if="commentKey == index" style="margin-left: 45px;margin-top: 10px;">
                      <a-form :form="form">
                        <a-form-item>
                          <a-textarea :rows="3" :placeholder="$t('news.editPage.commentTip')" v-decorator="['content',{rules:[
                              {required:true, message:$t('news.editPage.errorInfo.comment')},
                              {min:1,max:256,message:$t('news.editPage.errorInfo.commentLength')}
                              ]}]"></a-textarea>
                        </a-form-item>
                      </a-form>
                      <div class="commentInputBtnRow">
                        <a-button type="primary" :loading="saveLoading" @click="submitCommentOnComment(item.tree)">{{$t('baseVO.confirm')}}</a-button>
                        <a-button @click="cancelComment" style="margin-right:10px;">{{$t('baseVO.cacel')}}</a-button>
                      </div>
                    </div>
                    <div v-if="item.children && item.children.length > 0" class="innerCommentDiv">
                      <div v-for="(innerItem,innerIndex) in item.children">
                        <div class="innerItemTop">
                          <div class="innerItemLeft">
                            <span class="innerUser">{{innerItem.tree.createName}}</span>
                            <span class="innerReplyText">{{$t('news.editPage.reply')}}</span>
                            <span class="innerUser">{{innerItem.tree.toUserName}}</span>
                            <span style="margin: 0 4px;">:</span>
                            <span class="innerText">{{innerItem.tree.content}}</span>
                          </div>
                          <div class="innerItemRight">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="editMode">
            <issue-news :isNewsAmendment="isNewsAmendment" :show-type-row="false" :value="newsDO" ref="issueNewsRef" :defaultRentUnit="defaultRentUnit" :defaultAreaUnit="defaultAreaUnit"></issue-news>
          </div>
	        
	        <div v-if="newsDO.informationType == '交易记录'">
		        <now-update-item :update-datas="updateList"></now-update-item>
	        </div>
        
        </div>
      </div>
    </a-skeleton>
    <pt-modal :title="$t('news.transferNewsTitle')" :visible="issueModal.visible" :loading="issueModal.loading"
              :width="800" @cancel="cancelIssue" @ok="issueNewsEvent"
    >
      <div slot="content">
        <news-lease-form ref="dealFormRef" :defaultRentUnit="defaultRentUnit" :defaultAreaUnit="defaultAreaUnit" :fromNewsDO="newsDO" :transfer="true"></news-lease-form>
      </div>
    </pt-modal>

    <pt-modal :title="$t('news.deleteNewsTitle')" :visible="deleteModal.visible" :loading="deleteModal.loading"
              :width="800" @cancel="cancelDelete" @ok="deleteNew"
    >
      <div slot="content">
          <a-form-model ref="deleteFromRef" :model="deleteFrom" class="required">
            <a-form-model-item prop="deleteRemarks" :label="$t('news.deleteNewsRemars')" :rules="[
              {required:true,message:$t('common.enterDeletionReason'),target:['change', 'blur']},
              { max: 200,type:'string', message: $t('common.max200Characters'), trigger: 'blur'}
            ]">
              <a-textarea  :rows="5" v-model="deleteFrom.deleteRemarks" :placeholder="$t('key82qingshuru')"  :maxLength="200"></a-textarea>
            </a-form-model-item>
          </a-form-model>
      </div>
    </pt-modal>

  </div>
</template>

<script>
  import unitApi from '@/api/manager/unit'
  import newsLikeApi from '@/api/mine/newsLike'
  import newsApi  from '@/api/mine/news'
  import newsTypeLabel from './newsTypeLabel'
  import dealForm from '../../work/modal/dealForm'
  import newsCommentApi from '@/api/mine/newsComment'
  import commentTree from '@/components/commentTree/commentTree'
  import issueNews from '../../work/issueNews'
  import {findCascadingData,getDatadictChildsByPath} from '@/api/sys/datadict'
  import { getByCompanyIdAndType, unitTypeEnum } from '@/api/manager/unitUse'
  import NewsLeaseForm from '../../work/modal/newsLeaseForm'
  import UserApi from '@/api/sys/user'
  import { userMixin } from '@/utils/mixin'
  import NowUpdateItem from "@/views/mine/news/module/nowUpdateItem.vue";
  export default {
    name: 'newsDetail',
    components:{
	    NowUpdateItem,
      newsTypeLabel,dealForm, commentTree, issueNews, NewsLeaseForm
    },
    mixins:[userMixin],
    props:{
      showOperation:{
        type:Boolean,
        default:true
      },
      newsId:{
        type: String,
        default: null
      },
      isCommentEnter:{
        type: Boolean,
        default: false,
      },
      searchOverallFlag:{
        type: Boolean,
        default: false,
      }
    },
    data(){
      return{
        issueModal:{
          visible:false,
          loading:false,
        },
        deleteModal:{
          visible:false,
          loading:false,
        },
        isAdmin:false,
        defaultAreaUnit: null,
        defaultRentUnit: null,
        isAuthor:false,
        commentKey:null,
        form: this.$form.createForm(this,{}),
        loading:true,
        city:null,
        // cityStr:null,
        cityDatas:[],
        newsDO:null,
        newsCommentDO: this.$form.createForm(this,{}),
        newsCityForm: this.$form.createForm(this,{}),
        newsType:0,
        editMode:false,
        isNewsAmendment:false,
        commentList:[
        ],
        formToken:'',
        saveLoading:false,
        newsLikeDOS:[],
        unitAllData:[],
        commentTree:[],
        peerForm:{},
        ownerForm:{},
        tenantForm:{},
        generalForm:{},
        agentForm:{},
        decorators:{
          content:['content',{rules:[{required:true, message:this.$t('news.editPage.errorInfo.comment')}]}]
        },
        deleteFrom:{
          deleteRemarks:"",
        },
	      updateList:[],
      }
    },
    mounted(){
      this.init();
      this.initFormToken()
      this.initDefaultAreaUnit()
      this.initDefaultRentUnit()
    },
    computed:{
      isOldData(){
        if(this.newsDO){
          return this.$moment(this.newsDO.createTime).isBefore(this.$moment('2020-03-22'))
        }else{
          return false
        }
      },
      cityStr(){
        let city = null;
        if(this.newsDO && this.newsDO.city){
          city = this.cityDatas.find(e=>{ return e.id == this.newsDO.city})
        }
        return city != null ? city.city : null
      },
      newsContent(){
        let newsDO = this.newsDO;
        if(newsDO.displayContent != '~'){
          if(newsDO.informationType == '交易记录'){
            let content = newsDO.displayContent
            if(newsDO.leaseLeaseInfoTypeVOS.length > 0){
              content += '<br/>' + newsDO.leaseLeaseInfoTypeVOS[0].leaseLeaseInfoVO.remarks
            }
            return content
          }
          else{
            if(newsDO.confidentialityStatus == 1){
              return '<span style="margin-right: 30px"></span>'+newsDO.displayContent
            }else{
              return newsDO.displayContent
            }
          }
        }else{
          let content = ''
          if(newsDO.informationType == '交易记录'){
            let dealTypes = newsDO.dealType.split(',')
            content = newsDO.customerName
            let dealTypesArr = []
            dealTypes.forEach(e=>{
              dealTypesArr.push(this.$t('deal.dealTypes.' + e))
              // content += this.$t('deal.dealTypes.' + e)
            })
            content += dealTypesArr.join(',')
            content += newsDO.newBuilding != '~' ? newsDO.newBuilding : ''
            content += newsDO.newArea != '~' ? this.$t('news.content.newsArea') + newsDO.newArea + this.filterUnit(newsDO.newAreaUnit): ''
            content += (newsDO.startTime != '~') ? this.$t('news.content.startTime') + this.$moment(newsDO.startTime).format('YYYY-MM-DD') : ''
            content += newsDO.rent != '~' ? this.$t('news.content.newRent') + newsDO.rent + this.filterUnit(newsDO.rentUnit): ''
            content += newsDO.increasing != '~' ? ',' + newsDO.increasing + this.$t('news.content.increasing') : ''
            content += newsDO.rentFreePeriod != '~' ? this.$t('news.content.newRentFreePeriod') + newsDO.rentFreePeriod + this.$t('news.content.months'):''
            content += newsDO.intermediaryStr != '~' ? this.$t('news.content.intermediary') + newsDO.intermediaryStr : ''
            if(newsDO.leaseLeaseInfoTypeVOS.length > 0){
              content += newsDO.leaseLeaseInfoTypeVOS[0].leaseLeaseInfoVO.remarks
            }
          }else{
            if(newsDO.confidentialityStatus == 1){
              return '<span style="margin-right: 30px"></span>'+ (newsDO.displayContent != '~' ? newsDO.displayContent : newsDO.content)
            }else{
              content = newsDO.displayContent != '~' ? newsDO.displayContent : newsDO.content
            }

          }
          return content
        }
      }
    },
    methods:{
      initFormToken(){
        UserApi.getFormToken().then(res=>{
          if(res.code == 1){
            this.formToken = res.data;
          }
        })
      },
      transfer(){
        this.issueModal.visible = true
      },
      issueNewsEvent(){
        let newsDO = this.$refs.dealFormRef.submit()
        if(!newsDO){
          return false;
        }
        this.issueModal.loading = true;
        newsDO.fromNewsId = this.newsDO.id
        newsApi.transfer(newsDO).then(res=>{
          if(res.code == 1){
            this.$message.success(res.message)
            this.issueModal.visible = false;
            this.issueModal.loading = false;
            this.$emit('refreshList')
            this.refreshNewsDO()
          }else{
            this.$message.error(res.message)
            this.issueModal.loading = false;
          }
        })
      },
      cancelIssue(){
        this.issueModal.visible = false;
        this.issueModal.loading = false;
      },
      cancelDelete(){
        this.deleteModal.visible = false;
        this.deleteModal.loading = false;
      },
      initDefaultAreaUnit(){
        let p = new Promise((resolve,reject)=>{
          getByCompanyIdAndType(unitTypeEnum.AREA).then(res=>{
            if(res.code == 1){
              this.defaultAreaUnit = res.data[0]
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      initDefaultRentUnit(){
        let p = new Promise((resolve,reject)=>{
          getByCompanyIdAndType(unitTypeEnum.RENT).then(res=>{
            if(res.code == 1){
              this.defaultRentUnit = res.data[0]
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      cancelComment(){
        this.commentKey = null;
      },
      changeCommentKey(index,type){
        if(type == 'inner'){
          if(this.commentKey == 'inner'+index){
            this.commentKey = null;
          }else{
            this.commentKey = 'inner'+index;
          }
        }else{
          if(this.commentKey == index){
            this.commentKey = null;
          }else{
            this.form = this.$form.createForm(this,{})
            this.commentKey = index;
          }
        }
      },
      getImageUrl(img){
        return this.$util.getFileUrl(img)
      },
      filterUnit(unitId){
        let curUnit = this.unitAllData.find(data =>{
          return data.id == unitId
        })
        if(curUnit){
          return curUnit.shortName;
        }else{
          return '';
        }
      },
      filterLike(likeData){
        let me = this.$store.getters.userInfo.accountDO.id;
        let visible = false;
        if(likeData != null && likeData.length > 0){
          likeData.filter(e=>{
            return e.type == 1
          }).forEach((item,index) => {
            if(item.createrId == me){
              visible = true;
            }
          })
        }
        return visible;
      },
      filterDislike(likeData){
        let me = this.$store.getters.userInfo.accountDO.id;
        let visible = false;
        if(likeData != null && likeData.length > 0){
          likeData.filter(e=>{
            return e.type == 0
          }).forEach((item,index) => {
            if(item.createrId == me){
              visible = true;
            }
          })
        }
        return visible;
      },
      editEvent(){
        if(this.newsDO && this.newsDO.informationType == '交易记录' &&  this.newsDO.dealType != '购买' && this.newsDO.leaseLeaseInfoTypeVOS.length == 0){
          this.$message.warn(this.$t('news.noEditText'))
        }else{
          this.editMode = true;
          this.isNewsAmendment = false;
          this.$nextTick(()=>{
            this.newsCityForm.setFieldsValue(this.newsDO)
          })
        }
      },
      newsAmendmentEvent(){

        this.editMode = true;
        this.isNewsAmendment = true;
        this.$nextTick(()=>{
          this.newsCityForm.setFieldsValue(this.newsDO)
        })

      },
      deleteConfirm(){
        this.deleteModal.visible = true;
        this.deleteFrom.deleteRemarks = "";
      },
      deleteNew(){
        let _this = this
        this.deleteModal.loading = true;
        this.$refs.deleteFromRef.validate(err=> {
          if (err) {
            newsApi.adminDelete(_this.newsId,_this.deleteFrom.deleteRemarks).then(res => {
              this.deleteModal.loading = false;
              if (res.code == 1) {
                _this.$message.success(res.message)
                _this.$emit('refreshList')
                _this.$drawer.drawerInfoClose()
              } else {
                _this.$message.error(res.message)
              }
            }).finally(()=>{
              this.deleteModal.loading = false;
            })
          } else {
            this.deleteModal.loading = false;
            this.$message.warning("请输入删除原因!")
          }
        });
      },
      deleteMyNews(){
        let _this = this
        this.$ptConfirm({
          title: _this.$t('news.delete.title'),
          content: _this.$t('news.delete.content'),
          okType: 'primary',
          onOk() {
              newsApi.delete(_this.newsId).then(res=>{
                if(res.code == 1){
                  _this.$message.success(res.message)
                  _this.$emit('refreshList')
                  _this.$drawer.drawerInfoClose()
                }else{
                  _this.$message.error(res.message)
                }
              })
          },
          onCancel() {

          },
        });

      },
      cancelEdit(){
        this.editMode = false;
        this.isNewsAmendment = false;
      },
      clickLike(){
        this.submitNewsLike({type:1,newsId:this.newsDO.id, newsCreaterId:this.$store.getters.userInfo.accountDO.id})
      },
      clickDisLike(){
        this.submitNewsLike({type:0,newsId:this.newsDO.id, newsCreaterId:this.$store.getters.userInfo.accountDO.id})
      },
      init(){
        if(this.isCommentEnter){
          this.commentKey = 'root';
        }else{
          this.commentKey = null;
        }
	      this.getSelectUpdateList();
        this.refreshNewsDO(this.newsId)
        this.initCommentList()
        this.initNewsLike()
        this.initcityData()
        this.initAllUnit()
      },
      initAllUnit(){
        unitApi.selectAll().then(res=>{
          if(res.code == 1){
            this.unitAllData= res.data ? res.data:[]
          }
        })
      },
      initcityData(){
        getDatadictChildsByPath('system.business_key.news_setup').then(res=>{
          this.initCityDatas(res.data);
        })
      },
      initCityDatas(datas){
        this.cityDatas = [];
        newsApi.getUserCitys().then((res)=>{
          let citys = res.data;
          citys.forEach(data=>{
            datas.forEach(dictData=>{
              if(data == dictData.wordKey){
                this.cityDatas.push(dictData)
              }
            })
          })
        })
      },
      refreshNewsDO(){
        this.loading = true
        let this_ = this;
        let me = this.$store.getters.userInfo.accountDO.id;
        newsApi.selectOne(this.newsId).then(res=>{
          if(res.code == 1){
            this_.newsDO = res.data;
            if(this_.newsDO.createrId == me || me == '7f76b434c67621c2'){
              this_.isAuthor = true;
              if(me == '7f76b434c67621c2'){
                this_.isAdmin = true;
              }else{
                this_.isAdmin = false;
              }
            }
          }
        }).finally(()=>{
          this.loading = false
        })
      },
	    getSelectUpdateList(){
				newsApi.selectUpdateList(this.newsId).then(res=>{
					if(res.code == 1){
						this.updateList = res.data;
					}
				})
	    },
      initCommentList(){
        let this_ = this
        newsCommentApi.selectByNewsId(this.newsId).then(res=>{
          if(res.code == 1){
            this_.commentTree = res.data != null ? res.data.children : null
          }
        })
      },
      initNewsLike(){
        let this_ = this
        newsLikeApi.selectByNewsId(this.newsId).then(res=>{
          if(res.code == 1){
            this_.newsLikeDOS = res.data
          }else{

          }
        })
      },
      saveEdit(){
        let newsDO = this.$refs.issueNewsRef.getFormData()
        let city = this.newsCityForm.getFieldsValue().city
        newsDO.city = city
        this.$loading.show("loading...")
        newsApi.update(newsDO).then(res=>{
          if(res.code == 1){
            this.$message.success(res.message)
            this.editMode = false;
            this.$emit('saveSuccess')
            this.refreshNewsDO()
          }else{
            this.$message.error(res.message)
          }
        }).finally(()=>{
          this.$loading.hide();
        })
      },
      newsAmendmentSave(){
        let _this = this;
        let newsDO = this.$refs.issueNewsRef.getFormData()
        let city = this.newsCityForm.getFieldsValue().city
        newsDO.city = city
        this.$loading.show("loading...")
        newsApi.newsAmendment(newsDO).then(res=>{
          if(res.code == 1){
            this.$message.success("市场动态修订成功")
            this.editMode = false;
            _this.$emit('refreshList')
            _this.$drawer.drawerInfoClose()
          }else{

          }
        }).finally(()=>{
          this.$loading.hide();
        })
      },
      submitNewsLike(obj){
        newsLikeApi.clickNewsLike(obj).then(res=>{
          if(res.code == 1){
            this.newsLikeDOS = res.data == null ? [] : res.data
            this.$message.success(res.message)
            this.$emit('saveSuccess')
            this.refreshNewsDO(this.newsId)//点赞成功之后刷新页面
          }else{
            this.$message.error(res.message)
          }
        })
      },
      toggleCommentInput(){
        this.commentKey = 'root';
      },
      submitComment(){
        this.saveLoading = true
        this.newsCommentDO.validateFields(err=>{
          if(!err){
            let newsCommentDO = this.newsCommentDO.getFieldsValue()
            newsCommentDO.newsId = this.newsDO.id
            newsCommentDO.formToken = this.formToken
            newsCommentApi.insert(newsCommentDO).then(res=>{
              this.saveLoading = false
              if(res.code == 1){
                this.$message.success(res.message)
                this.commentKey = null;
                this.initCommentList();
                this.newsCommentDO.setFields({content:''})
                this.initFormToken()
                this.$emit('saveSuccess')
              }else{

              }
            }).catch(()=>{
              this.saveLoading = false
            })
          }else{
            this.saveLoading = false
          }
        })
      },
      submitCommentOnComment(treeNode){
        this.saveLoading = true;
        this.form.validateFields(err=> {
          if (!err) {
            let curForm = this.form.getFieldsValue();
            let node = {newsId: this.newsDO.id, parentId: treeNode.id, content: curForm.content,formToken:this.formToken}
            newsCommentApi.insert(node).then(res=>{
              this.saveLoading = false;
              if(res.code == 1){
                this.$message.success(res.message)
                this.commentKey = null
                this.initCommentList();
                this.initFormToken()
                this.$emit('saveSuccess');
              }else{

              }
            }).catch(()=>{
              this.saveLoading = false;
            })
          }else{
            this.saveLoading = false;
          }
        })
      },
      toggleInnerCommentInput(item,visible){
        item.visible = visible;
      }
    },
    watch:{
      newsId(){
        this.init()
      },
      isCommentEnter(newValue){
        if(newValue){
          this.commentKey = 'root';
        }else{
          this.commentKey = null;
        }
      }
    }
  }
</script>
<style scoped lang="less">
  .newsDetail .commentDiv .ant-form-item{
    margin-bottom: 0 !important;
  }
  .newsDetail{
    .commentItem{
      border-top: 1px solid #E1E1E1;
      padding-top: 26px;
      margin-bottom: 18px;
      .commentIconDiv{
        width: 20px;
        text-align: center;
        .commentIcon{
          font-size: 14px;
          cursor: pointer;
        }
        .commentIcon:hover{
          transform: scale(1.2);
        }
      }
      .commentItemTop{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .commentItemTopDiv{
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-right: 10px;
        }
        .commentUser{
          margin-left: 10px;
          font-size: 14px;
          color: #4D4D4D;
        }
        .commentTime{
          font-size: 14px;
          color: #909090;
          margin-right: 40px;
        }
      }
      .commentContentDiv{
        position: relative;
        margin-left: 45px;
        .contentArrow{
          position: absolute;
          border: 6px solid rgba(0,0,0,0);
          height: 0;
          line-height: 0;
          font-size: 0;
          top: -12px;
          left: 0;
          border-bottom-color:rgba(244,245,248,0.6);
          border-left-color:rgba(244,245,248,0.6);
        }
        .commentContent{
          padding: 10px;
          background: rgba(244,245,248,0.6);
          border-radius: 0 0 5px 5px;
          font-size: 14px;
          color: #323232;
          letter-spacing: 0;
          text-align: justify;
          line-height: 24px;
          word-break: break-all;
          word-wrap: break-word;
        }
      }
      .innerCommentDiv{
        margin-left: 45px;
        margin-top: 9px;
        padding: 10px;
        background: rgba(244,245,248,0.6);
        border-radius: 0 0 5px 5px;
      }
      .innerItemTop{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 4px;
      }
      .innerItemLeft{
        .innerUser{
          font-size: 14px;
          color: #188BE3;
          line-height: 24px;
        }
        .innerReplyText{
          margin: 0 10px;
          font-size: 14px;
          line-height: 24px;
          color: #333333;
        }
        .innerText{
          font-size: 14px;
          color: #323232;
          line-height: 24px;
          word-break: break-all;
          word-wrap: break-word;
        }
      }
      .innerItemRight{
        justify-content: flex-end;
      }
    }
    .btnRow{
      width: 100%;
      height: 50px;
      padding: 0 40px;
      background: #FAFBFC;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
    }
    .editBtn{
      padding: 0 8px;
      height: 30px;
      background: #ffffff;
      border: 1px solid #CFD3D7;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor:pointer;
      .editIcon{
        font-size: 14px;
        margin-right: 2px;
      }
      span{
        font-size: 12px;
        color: #666666;
      }
    }
    .mainDiv{
      position: relative;
      padding: 0 40px;
    }
    .citySwitch{
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-right: 4px;
      .cityIcon{
        font-size: 16px;
        color: #BCBCBC;
        margin-right: 4px;
      }
      .cityText{
        font-size: 12px;
        color: #333333;
      }
    }
    .topRow{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 127px;
      border-bottom: 1px solid #E1E1E1;
      .topRowLeft{
        display: flex;
        flex-direction: row;
        align-items: center;
        .authorText{
          margin-left: 20px;
          font-size: 24px;
          color: #4D4D4D;
        }
      }
      .topRowRight{
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .newsTime{
        font-size: 14px;
        color: #909090;
        margin-left: 40px;
        margin-right: 50px;
      }
    }
    .likeRow{
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      margin-top: 30px;
      margin-bottom: 10px;
      .likeItem{
        display: flex;
        align-items: center;
        margin-left: 25px;
        span{
          font-size: 18px;
          color: #6D6B6A;
          margin-left: 4px;
        }
        div{
          margin-left: 10px;
        }
      }
      .likeIcon{
        font-size: 16px;
      }
      .likeItem .likeIcon:hover{
        transform: scale(1.2);
      }
    }
    .secrecyIcon{
      position: absolute;top: 207px;left: 60px;
    }
    .newsContent{
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
      padding: 20px;
      font-size: 14px;
      color: #323232;
      letter-spacing: 1px;
      text-align: justify;
      line-height: 24px;
      word-wrap: break-word;
      word-break: break-all;
    }
    .commentIcon{
      font-size: 14px;
      cursor: pointer;
    }
    .newsTypeRow{
      font-size: 18px;
      color: #333333;
      line-height: 64px;
    }
    .newsFormDiv{
      border-top: 1px solid #E1E1E1;
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
      margin-bottom: 160px;
      padding-bottom: 40px;
    }
    .newsFormDiv2{
      border-top: 1px solid #E1E1E1;
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
      margin-bottom: 160px;
      padding: 20px 20px 40px 20px;
    }
    .commentDiv{
      .commentBtnRow{
        display: flex;
        flex-direction: row-reverse;
        margin-top: 10px;
      }
      .commentInputBtnRow{
        display: flex;
        flex-direction: row-reverse;
      }
      .commentBtn{
        height: 30px;
        padding: 0 10px;
        background: #FAFBFC;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        span{
          margin-left: 2px;
          font-size: 12px;
          color: #666666;
        }
      }
      .commentBtn:hover .commentIcon{
        transform: scale(1.2);
      }
      .commentInput{
        padding: 15px 20px;
      }
    }
  }
</style>